import React from 'react';
import PropTypes from 'prop-types';

import BaseWizard from 'containers/BaseWizard';
import EmptySidebar from 'containers/BaseWizard/components/Sidebars/EmptySidebar';

import PathSelectionPage from './PathSelectionPage';


const WizardLandingPage = ({ wizardStore, handleClose, handlePath, selectPath }) => {
  return (
    <BaseWizard
      enableFooter
      buttonText="Next"
      wizardStore={wizardStore}
      sidebarComponent={<EmptySidebar />}
      onClose={handleClose}
    >
      <PathSelectionPage onChange={handlePath} onFooterNext={selectPath} />
    </BaseWizard>
  );
};

WizardLandingPage.propTypes = {
  wizardStore: PropTypes.object,
  handleClose: PropTypes.func,
  handlePath: PropTypes.func,
  selectPath: PropTypes.func,
};

export default WizardLandingPage;
